// routes/StepGuardRoute.js
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const StepGuardRoute = ({
  component: Component,
  currentStepIndex,
  registrationSteps,
  path,
  ...rest
}) => {
  const { isInRegistration } = useSelector((state) => state.registration)
  const stepIndex = registrationSteps.indexOf(path);

  return (
    <Route
      {...rest}
      path={path}
      render={(props) => {
        if (!isInRegistration) {
          // If not in registration, allow free access
         return <Redirect to="/dashboard" />;
         // return <Component {...props} />;
        }
        // If the current step index is less than the required step, redirect
        if (stepIndex !== currentStepIndex) {
          return <Redirect to={registrationSteps[currentStepIndex]} />;
        }
        // If the current step index is greater or equal, render the component
        return <Component {...props} />;
      }}
    />
  );
};

export default StepGuardRoute;
